import { render, staticRenderFns } from "./AssignUser.vue?vue&type=template&id=6896c0d1&"
import script from "./AssignUser.vue?vue&type=script&lang=js&"
export * from "./AssignUser.vue?vue&type=script&lang=js&"
import style0 from "./AssignUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports